import PageHeader from './PageHeader';

export { PageHeader as default };



// WEBPACK FOOTER //
// /src/js/common/pageHeader/index.js